"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M10.772 9.764a2.449 2.449 0 000 3.46l.8-.802a1.315 1.315 0 010-1.857l1.855-1.854c.247-.248.577-.385.928-.385a1.315 1.315 0 01.928 2.242l-.667.667.802.801.667-.667a2.449 2.449 0 000-3.46 2.431 2.431 0 00-1.73-.716 2.43 2.43 0 00-1.73.717l-1.853 1.854z" }),
    React.createElement("path", { d: "M7.915 16.042a2.439 2.439 0 001.73.716c.626 0 1.253-.239 1.73-.716l1.854-1.854a2.449 2.449 0 000-3.459l-.801.801a1.315 1.315 0 010 1.857l-1.854 1.854a1.315 1.315 0 01-2.242-.928c0-.351.136-.681.384-.929l.667-.667-.8-.801-.668.667a2.449 2.449 0 000 3.46z" })), "Link");
//# sourceMappingURL=Link.js.map